import React from 'react';
import "./agent-ui.css";

const DashSummary = ({eachSum, loading}) => {

  return (
    <div className='dash-sum'>
        {eachSum?.map((item, i) => {
            return (
                <div key={i} className={loading ? "each-sum opacity2" : "each-sum"}>
                    {!loading && <p><span>{item.total}</span>{item.text}</p>}
                </div>
            )
        })}
    </div>
  )
}

export default DashSummary